import React, { useContext, useState } from 'react';

import { Link } from '@mui/material';

import { DataTable } from '../../common/components/DataTable';
import { GridView } from '../../common/components/GridView';
import { FlexRow, Spacer } from '../../common/components/v2';
import { FeatureFlags } from '../../common/constants/featureFlags';
import { Resource } from '../../common/constants/resource';
import { FeatureFlagsContext } from '../../common/featureFlagsWrapper';
import { RxApplicationSection } from '../detail/tasks/rx/RxApplicantSection';
import { RxDetailsColumnResolver } from '../detail/tasks/rx/RxDetailsColumnResolver';
import { RxDetailsColumns } from '../detail/tasks/rx/RxDetailsColumns';
import { RxHistoryV2 } from '../detail/tasks/rx/RxHistoryV2';
import { RxRulesColumnResolver } from '../detail/tasks/rx/RxRulesColumnResolver';
import { RxRulesColumns } from '../detail/tasks/rx/RxRulesColumns';
import { useRxSorting } from '../detail/tasks/rx/useRxSorting';
import { Evidence } from '../tasks/types/evidence';
import { RxApplicationDetails } from '../tasks/types/rx';
import styles from './styles.module.scss';

const RXDisplayLegacy = ({ rxDetail }: { rxDetail: RxApplicationDetails }) => {
  const [showAllRules, setShowAllRules] = useState({
    isShowingAll: false,
  });
  const showMoreOrLess = () => {
    setShowAllRules({ isShowingAll: !showAllRules.isShowingAll });
  };

  const { sortFields, sortFunction } = useRxSorting(rxDetail.rx || []);

  RxDetailsColumns.forEach(col => {
    if (sortFields.includes(col.name)) {
      col.fetchFn = sortFunction;
    }
  });

  return (
    <>
      {RxApplicationSection(rxDetail)}
      <Spacer height={16} />
      {rxDetail.rx.length ? (
        <DataTable
          rows={rxDetail.rx}
          columns={RxDetailsColumns}
          columnsResolver={RxDetailsColumnResolver}
          expandableRows={true}
          defaultSortDirection="desc"
          defaultSortKey="severity"
        />
      ) : null}

      {rxDetail.rxRules?.length ? (
        <>
          <Spacer height={16} />
          <FlexRow className={styles.TaskSubtitle}>
            <span>{Resource.RX_RULES}</span>
            <span className={styles.RightEnd}>
              Showing{' '}
              {showAllRules.isShowingAll
                ? rxDetail.rxRules.length
                : Math.min(
                    Resource.RX_RULE_INITIAL_PAGE_SIZE,
                    rxDetail.rxRules.length,
                  )}{' '}
              of {rxDetail.rxRules.length}
            </span>
          </FlexRow>

          <GridView
            rows={
              showAllRules.isShowingAll
                ? rxDetail.rxRules
                : rxDetail.rxRules.slice(0, Resource.RX_RULE_INITIAL_PAGE_SIZE)
            }
            columns={RxRulesColumns}
            columnsResolver={RxRulesColumnResolver}
            expandableRows={false}
          />
          <Spacer height={8} />
          {rxDetail.rxRules.length > Resource.RX_RULE_INITIAL_PAGE_SIZE ? (
            <FlexRow className={styles.ShowMoreLess}>
              <Link onClick={showMoreOrLess}>
                {showAllRules.isShowingAll
                  ? Resource.RX_RULE_SHOW_LESS
                  : Resource.RX_RULE_SHOW_ALL}
              </Link>
            </FlexRow>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export const RXDisplay = ({ rxData }: { rxData: Evidence }) => {
  const rxDetail: RxApplicationDetails | null = rxData
    ? (rxData.facts as RxApplicationDetails)
    : null;

  const { flags } = useContext(FeatureFlagsContext);
  const isRxHistoryV2Enabled =
    !!flags[FeatureFlags.UW_NORA_RX_HISTORY_V2_ENABLED];

  if (!rxDetail) return null;

  if (isRxHistoryV2Enabled) {
    return (
      <>
        {RxApplicationSection(rxDetail)}
        <Spacer height={16} />
        <RxHistoryV2 rxDetail={rxDetail} />
      </>
    );
  }

  return <RXDisplayLegacy rxDetail={rxDetail} />;
};
